// extracted by mini-css-extract-plugin
export var header = "index-module--header--SYyVN";
export var leftText = "index-module--leftText--28q3w";
export var link = "index-module--link--2kirZ";
export var word = "index-module--word--3uYt_";
export var pronunciation = "index-module--pronunciation--2utbP";
export var definition = "index-module--definition--1aRyP";